export default "__VITE_ASSET__d21520e1__"